import { render, staticRenderFns } from "./TabStaticAssessment.vue?vue&type=template&id=6e4fecf1"
import script from "./TabStaticAssessment.vue?vue&type=script&lang=js"
export * from "./TabStaticAssessment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports